import * as React from 'react'
import { connect } from 'react-redux'

import * as actions from '../../../actions'
import { initializeWebViewInfo } from '../../../webview'
import Page from '../../molecules/page'

type WebViewProps = {
  setDasherId: (dasherId: string) => void
  loadDasherId: () => void
}

/**
 * Basic Webview wrapper that will provide authentication header setup to
 * support Android and iOS
 */
class WebViewWrapper extends React.Component<WebViewProps> {
  public componentDidMount() {
    const { loadDasherId, setDasherId } = this.props
    try {
      initializeWebViewInfo().then(({ dasherId }) => {
        if (dasherId) {
          setDasherId(dasherId)
        } else {
          loadDasherId()
        }
      })
    } catch (e) {
      console.warn(e)
    }
  }

  /**
   * render children wrapped in styled page div
   */
  public render() {
    return (
      <React.Fragment>
        <Page>{this.props.children}</Page>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = {
  setDasherId: actions.setDasherId,
  loadDasherId: actions.loadDasherId,
}

export default connect(null, mapDispatchToProps)(WebViewWrapper)
